<template>
  <div class="instructions">
    <h1>Návody na montáž</h1>
    <form class="form" v-on:submit.prevent="">
      <div class="row">
        <label for="main">Typ montáže</label>
        <div class="select">
          <select id="main" v-model="main">
            <option value="">-</option>
            <option value="can">CAN</option>
<!--            <option value="tacho">TACHO</option>-->
          </select>
        </div>
      </div>
      <div class="row" v-if="(main == 'can')">
        <label for="type">Typ</label>
        <div class="select">
          <select id="type" v-model="type" v-on:change="load('type')">
            <option value="">-</option>
            <option value="with">S převodníkem</option>
            <option value="without">Bez převodníku</option>
          </select>
        </div>
      </div>
      <div class="row" v-if="(main == 'can' && type != '')">
        <label for="brand">Značka</label>
        <div class="select specialSelect">
          <v-select id="brand" v-model="brand" :options="brands" @input="load('brand')" label="name">
            <template #no-options="{ search, searching, loading }">
              Zadaná značka neexistuje.
            </template>
            <template v-slot:option="brand">
              {{ brand.name }}
            </template>
          </v-select>
        </div>
      </div>
      <div class="row" v-if="(main == 'can' && type != '' && brand !== null)">
        <label for="brand">Hledat (model/rok výroby)</label>
        <input
            type="text"
            id="model"
            name="model"
            v-model="model"
            autocomplete="off"
            v-on:keyup="filter"
            v-on:touchend="filter"
        />
      </div>
    </form>
    <div class="results" v-if="(brand != null)">
      <div class="result" v-for="instruction in filteredInstructions" v-bind:key="instruction.id">
        <p>{{instruction.niceName}}</p>
        <a v-bind:href="instruction.link" target="_blank" class="btn">Stáhnout</a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "../store";
import moment from "moment";

export default {
  name: "Instructions",
  mounted() {
    document.title = "GPS Dozor Servis | Návody";
    //this.checkStart();
    //this.loadHistory();
  },
  components: {},
  computed: {
    idUnit() {
      return store.state.idUnit;
    },
    result() {
      return store.state.checkResult;
    },
    checkContinue() {
      //if(this.client === "") return true;
      if (this.name === "") return true;
      if (this.plate === "") return true;
      if (this.type === "") return true;
      if (this.color === 0) return true;
      if (this.hasTachometer && this.tachometer === "") return true;
      return false;
    },
    getColorCode() {
      if (this.color == null) {
        return "";
      }
      return this.color.code;
    },
    getInvoiced() {
      return 19;
    },
    getTotal() {
      return 19;
    },
    getRole() {
      return store.state.role;
    }
  },
  data: function() {
    return {
      date: moment(),
      invoicedCount: 0,
      mountedCount: 0,
      units: null,
      main: 'can',
      type: '',
      brand: null,
      model: '',
      brands: [],
      instructions: [],
      filteredInstructions: [],
    };
  },
  methods: {
    setType: function(id) {
      this.type = id;
    },
    saveSubmit: async function() {
      store.commit("showLoading");
      const result = await store.dispatch("save", {
        client: this.client,
        name: this.name,
        plate: this.plate,
        color: parseInt(this.color.id),
        type: parseInt(this.type),
        hasTachometer: this.hasTachometer,
        tachometer: parseInt(this.tachometer),
        typeMontage: parseInt(this.typeMontage),
        price: this.price,
        km: this.km,
        note: this.note
      });
      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      if (result) {
        store.commit("saveState");
        this.$router.push("finish");
      } else {
        this.info = "Chyba";
      }
    },
    checkStart: function() {
      if (store.state.checkResult === null) {
        this.$router.push("check");
        return;
      }
    },
    loadHistory: async function() {
      store.commit("showLoading");
      const result = await store.dispatch("history", {
        date: this.date.format("YYYY-MM-DD")
      });
      store.commit("hideLoading");

      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      this.invoicedCount = 0;
      this.mountedCount = 0;

      result.forEach(date => {
        const companies = date.companies;

        companies.forEach(company => {
          const units = company.units;
          company.closed = false;
          var companyInvoiced = 0;

          units.forEach(unit => {
            if (unit.invoiced) {
              this.invoicedCount++;
              companyInvoiced++;
            }

            this.mountedCount++;
          });

          if (companyInvoiced === units.length) {
            company.totalInvoiced = true;
          }
        });
      });

      this.units = result;
    },
    setMonth: function(dir) {
      if (dir) {
        this.date = moment(this.date).add(1, "months");
      } else {
        this.date = moment(this.date).subtract(1, "months");
      }
      this.loadHistory();
    },
    formatDate: function(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    getType: function(type) {
      const types = ["Small", "Sedan", "Combi", "Van", "Bus", "Truck"];

      return types[type];
    },
    getTypeMontage: function(typeMontage) {
      const typesMontage = [
        "Standardní montáž",
        "Montáž včetně identifikace",
        "Montáž včetně CAN",
        "Demontáž",
        "Jiný (poznámka)"
      ];

      return typesMontage[typeMontage];
    },
    getColor: function(color) {
      const colors = [
        "Šedá/bílá",
        "Modrá",
        "Černá",
        "Zelená",
        "Růžová",
        "Žlutá"
      ];

      return colors[color];
    },
    toggleCompany: function(company) {
      company.closed = !company.closed;
    },
    toggleInvoicedUnit: async function(unit, company) {
      unit.invoiced = !unit.invoiced;

      await store.dispatch("editUnit", {
        unit: unit
      });

      if (unit.invoiced) {
        this.invoicedCount++;
      } else {
        this.invoicedCount--;
      }

      var companyInvoiced = 0;
      company.units.forEach(unit => {
        if (unit.invoiced) {
          companyInvoiced++;
        }
      });
      if (companyInvoiced === company.units.length) {
        company.totalInvoiced = true;
      } else {
        company.totalInvoiced = false;
      }
    },

    toggleInvoicedCompany: async function(company) {
      company.totalInvoiced = !company.totalInvoiced;

      for (var i = 0; i < company.units.length; i++) {
        const unit = company.units[i];
        if (unit.invoiced == company.totalInvoiced) {
          continue;
        }
        unit.invoiced = company.totalInvoiced;
        if (unit.invoiced) {
          this.invoicedCount++;
        } else {
          this.invoicedCount--;
        }
        await store.dispatch("editUnit", {
          unit: unit
        });
      }
    },
    editUnit: async function(unit) {
      const result = await store.dispatch("getUnit", {
        unit: unit
      });
      if (result.editable) {
        this.$router.push({ name: "Save", params: { unit: unit } });
      } else {
        alert("Tuto jednotku již nejde editovat");
        unit.editable = false;
      }
    },
    deleteUnit: async function(unit, company) {
      const result = await store.dispatch("getUnit", {
        unit: unit
      });
      if (result.editable) {
        if (confirm("Opravdu chcete smazat tuto jednotku?")) {
          store.commit("showLoading");
          await store.dispatch("deleteUnit", {
            unit: unit
          });
          store.commit("hideLoading");

          const units = company.units;
          let newUnits = [];
          units.forEach(unitTemp => {
            if (unitTemp.originalId != unit.originalId) {
              newUnits.push(unitTemp);
            }
          });
          company.units = newUnits;
          this.invoicedCount--;
          this.mountedCount--;
        }
      } else {
        alert("Tuto jednotku již nejde smazat.");
        unit.editable = false;
      }
    },

    load: async function(type) {
      if(this.type == ''){
        return;
      }

      if(type == "type"){
        this.brand = null;
        this.brands = [];
        this.instructions = [];
        this.filteredInstructions = [];
      }

      store.commit("showLoading");

      if(type == "brand" && this.brand === null && this.brands.length > 0){
        store.commit("hideLoading");
        return;
      }

      const result = await store.dispatch("getInstructions", {
        main: this.main,
        type: this.type,
        brand: (this.brand!==null)?this.brand.id:null,
      });
      store.commit("hideLoading");

      if(this.brand === null){
        this.brands = [];
        result.forEach(brand => {
          this.brands.push(brand);
        });
        this.brands = this.brands.sort((a, b) => a.name.localeCompare(b.name));
      }else{
        this.instructions = [];
        this.filteredInstructions = [];
        result.forEach(instruction => {
          instruction.link = "https://docs.google.com/gview?embedded=true&url="+instruction.link;
          this.instructions.push(instruction);
          this.filteredInstructions.push(instruction);
        });
      }

/*
      if (result === false && store.state.hash === null) {
        store.commit("resetState");
        store.commit("saveState");
        this.$router.push({
          name: "Login",
          params: { infoProps: "Z bezpečnostních důvodů došlo k odhlášení." }
        });
      }

      this.invoicedCount = 0;
      this.mountedCount = 0;



      this.units = result;*/
    },
    filter: function(){
      this.filteredInstructions = this.instructions;
      if(this.model != ""){
        this.filteredInstructions = this.filteredInstructions.filter((instruction)=>{
          return (instruction.niceName.toLowerCase()).includes(this.model.toLowerCase());
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/less/1-base/variables";
@import "~vue-select/dist/vue-select.css";

.instructions{
  h1 {
    text-align: center;
    margin-bottom: 40px;
    font-size: 24px;
  }

  .form{
    .row{
      margin-top: 10px;
    }
  }

  .results{
    margin-top: 20px;
    .result{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 4px;
      border-bottom: 1px solid @grey-10;
      padding: 4px 0;
      font-size: 12px;
      &:first-child{
        border-top: 1px solid @grey-10;
      }

      p{
        margin: 0;
      }

      .btn{
        font-size: 12px;
        padding: 4px;
        border-radius: 4px;
        background-color: @blue;
        color: @white-common;
        text-decoration: none;
        &:hover{
          background-color: darken(@blue,10);
        }
      }
    }
  }

  .specialSelect{
    border: 1px solid @grey-10;
    border-radius: 8px;
    padding: 3px 0;
    font-family: inherit;
  }
}
</style>
<style>
.vs__clear {
  width: auto;
  color: #524b47;
  margin-right: 20px;
}

.vs__clear:hover {
  color: #524b47;
  background-color: transparent;
}

.vs__dropdown-toggle {
  border: 0;
}

.vs__search {
  width: 0 !important;
}

.vs__actions{
}
.vs__open-indicator{
  display: none;
}
</style>